<div class="mb-25">
  <!-- Breadcrumb removed but spacing maintained -->
</div>

<div class="add-allocation-btn">
  <button mat-fab color="primary" matTooltip="Kreiraj zahtjev za izravnu dodjelu sredstava" (click)="goToCreateAllocation()">
    <mat-icon>add</mat-icon>
  </button>
</div>

<div class="allocations-container">
  @for (allocation of filteredAllocations; track allocation) {
    <div class="col-lg-4 col-md-6 allocation-card">
      <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">{{ allocation.organizationName }}</h5>
          </mat-card-title>
          <mat-card-subtitle>
            <p></p>
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p>
            <strong>Aktivnost:</strong> {{ allocation.activityName }}
          </p>
          <p>
            <strong>Traženi iznos:</strong> {{ allocation.amountRequestedFromMunicipality | currency:'EUR' }}
          </p>
          <p>
            <strong>Datum predaje:</strong> {{ allocation.submittedAt | date: 'd.M.yyyy. HH:mm:ss' }}
          </p>
          <p>
            <strong>Status:</strong>
            <span
              class="daxa-badge"
                    [ngClass]="{
                      'submited': allocation.status === AllocationStatus.Submitted,
                      'draft': allocation.status === AllocationStatus.Draft,
                      'returned': allocation.status === AllocationStatus.Returned,
                      'resubmitted': allocation.status == AllocationStatus.Resubmitted,
                      'approved': allocation.status === AllocationStatus.Approved,
                      'rejected': allocation.status === AllocationStatus.Rejected
                    }"
              >
              {{ allocation.userFriendlyStatus }}
            </span>
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button mat-icon-button color="primary" matTooltip="Pregledaj izravnu dodjelu sredstava" (click)="goToViewAllocation(allocation)">
            <mat-icon>visibility</mat-icon>
          </button>
          @if (allocation.isActionAllowed('Edit')) {
            <button mat-icon-button color="primary" matTooltip="Uredi izravnu dodjelu" (click)="goToEditAllocation(allocation)">
              <mat-icon>edit</mat-icon>
            </button>
          }
          @if (allocation.isActionAllowed('Delete')) {
            <button mat-icon-button color="warn" matTooltip="Obriši izravnu dodjelu" (click)="confirmDelete(allocation)">
              <mat-icon>delete</mat-icon>
            </button>
          }
          @if (allocation.isActionAllowed('Submit')) {
            <button mat-icon-button color="primary" matTooltip="Predaj izravnu dodjelu" (click)="confirmSubmit(allocation)">
              <mat-icon>check_circle</mat-icon>
            </button>
          }
          @if (allocation.isActionAllowed('Resubmit')) {
            <button mat-icon-button color="primary" matTooltip="Ponovno predaj izravnu dodjelu" (click)="confirmResubmit(allocation)">
              <mat-icon>check_circle</mat-icon>
            </button>
          }
          <button mat-icon-button color="primary" matTooltip="Preuzmi obrasce" (click)="downloadForms(allocation, [AllocationFormType.B1, AllocationFormType.B2])">
            <mat-icon>download</mat-icon>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  }
</div>
